<template>
    <div class="card">
        <div class="card-header border-0">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0">Facturas Proveedor</h3>
                    <!-- <h6 class="text-muted">{{type}}</h6> -->
                    <base-dropdown style="padding-top:10px">
                        <base-button slot="title" type="secondary" class="dropdown-toggle">
                        {{type}}
                        </base-button>
                        <a class="dropdown-item" @click="type='Facturas del sistema sin referencia de SAT'; showTableDataType()">Facturas del sistema sin referencia de SAT</a>
                        <a class="dropdown-item" @click="type='Facturas de SAT sin registro en SAP'; showTableDataType()">Facturas de SAT sin registro en el sistema</a>
                        <a class="dropdown-item" @click="type='Facturas conciliadas'; showTableDataType()">Facturas conciliadas</a>
                        <a class="dropdown-item" @click="type='Pagos de SAT sin registro en SAP'; showTableDataType()">Pagos de SAT sin registro en SAP</a>
                        
                    </base-dropdown>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <label class="text-left">Inicio</label>
                        <base-input style="cursor:pointer;">
                            <flat-picker slot-scope="{focus}"
                                @on-open="focus"
                                :config="{allowInput: true, maxDate: data.finish_date_consulted, minDate: data.start_date_consulted}"
                                class="form-control datepicker"
                                v-model="start_date"
                                style="cursor:pointer;padding-left:20px">
                            </flat-picker>
                        </base-input>
                    </div>
                    <div class="col-sm-4">
                        <label class="text-left">Fin</label>
                        <base-input style="cursor:pointer;">
                            <flat-picker slot-scope="{focus}"
                                @on-open="focus"
                                :config="{allowInput: true, maxDate: data.finish_date_consulted, minDate: data.start_date_consulted}"
                                class="form-control datepicker"
                                v-model="end_date"
                                style="cursor:pointer;padding-left:20px">
                            </flat-picker>
                        </base-input>
                    </div>
                    <div class="mt-4" style="padding-top:7px;">
                        <base-button
                            style="float: right"
                            tag="a"
                            type="primary"
                            href="#"
                            class="active"
                            role="button"
                            aria-pressed="true"
                            @click="searchPurchaseInvoices"
                            >Buscar
                        </base-button>
                    </div>
                    
                    
                </div>
            </div>
        </div>
        <div class="table-responsive" v-if="tableData.length !== 0">
            <data-table class="pl-2 pr-2 pb-5" v-bind="tableProps"/>
            <vue-json-to-csv
                :json-data="tableData"
                :csv-title="'file'">
                <base-button
                    style="float: right"
                    tag="a"
                    type="primary"
                    href="#"
                    class="active mr-4 mb-5"
                    role="button"
                    aria-pressed="true"
                    >Descargar CSV
                </base-button>
            </vue-json-to-csv>
        </div>
        <center v-if="isLoading" class="mb-3"><img src="img/loader.gif" class="img-responsive" style="width:50px;padding-bottom:10px;padding-top:13px"><br>Cargando...</center>
    </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import axios from 'axios'
import VueJsonToCsv from 'vue-json-to-csv'


export default {
    name: "conciliaciones",
    props: {
        limit: Number,
        title: String,
    },
    components:{
        flatPicker,
        VueJsonToCsv
    },
    data() {
        return {
            tableData: [],
            type: "Facturas del sistema sin referencia de SAT",
            dates: null,
            start_date:  null,
            end_date: null,
            isLoading: true,
            data: [],
            tableProps: {},
        };
    },
    created() {
        
    },
    mounted() {
        axios.get(`https://api.canplast.net/api/syncfy/transactions/filtered`)
        .then((result) => {
            console.log("🚀 ~ file: ConciliacionesList.vue ~ line 197 ~ .then ~ result", result)
            this.data = result.data
            this.start_date = moment().subtract(45, 'days').format("YYYY-MM-DD")
            this.end_date = moment().format("YYYY-MM-DD")
            this.showTableDataType()
        })
        .catch((error) => {
            console.log("🚀 ~ file: Conciliaciones.vue ~ line 89 ~ mounted ~ error", error)
        });
        setTimeout(() => {
            axios.get(`https://api.canplast.net/api/syncfy/transactions/filtered`)
            .then((result) => {
                console.log("🚀 ~ file: ConciliacionesList.vue ~ line 197 ~ .then ~ result", result)
                this.data = result.data
                this.start_date = moment().subtract(45, 'days').format("YYYY-MM-DD")
                this.end_date = moment().format("YYYY-MM-DD")   
                this.showTableDataType()
            })
            .catch((error) => {
                console.log("🚀 ~ file: Conciliaciones.vue ~ line 89 ~ mounted ~ error", error)
            });
        }, 2000);
    },
    methods:{
        searchPurchaseInvoices(){
            this.isLoading = true;
            this.showTableDataType()
            //this.$forceUpdate()
        },
        showTableDataType(){
            if(this.type == "Facturas del sistema sin referencia de SAT"){
                this.tableData = this.data.with_no_reference_on_sap.value.filter((item)=> moment(item.DocDate).format('x') >= moment(this.start_date).format('x') && moment(item.DocDate).format('x') <= moment(this.end_date).format('x'))
                this.tableData.sort((a,b) => moment(b.DocDate).format('x') - moment(a.DocDate).format('x'))
                this.tableProps =  {
                    data: this.tableData,
                    columns: [
                        { title:"Código", key: "CardCode"},
                        { title:"Cliente", key: "CardName" },
                        { title:"DocNum", key: "DocNum", type: "number" },
                        { title:"DocDate", key: "DocDate", type: "date" },
                        { title:"DocTotal", key: "DocTotal", type: "number" },
                        { title:"EDocNum", key: "EDocNum" },
                    ],
                    //allowedExports: ['csv', 'json'], 
showDownloadButton:false,
                    lang: 'es',
                    text: {
                        perPageText: "Número de facturas por página :entries",
                        infoText: "Mostrando :first hasta :last de :total facturas",
                        emptyTableText: "No se encontraron facturas :(",
                        searchText: "Buscar",
                        paginationSearchButtonText :"Ir",
                        paginationSearchText: "Ir a la página",
                        downloadButtonText: "Descargar",
                        downloadText:"Exportar como:",
                        previousButtonText:"<",
                        nextButtonText:">"
                    },
                    sortingMode: "single",
                    //loadingComponent: Spinner,
                    isLoading: true,
                }
                console.log("🚀 ~ file: ConciliacionesList.vue ~ line 220 ~ showTableDataType ~ tableProps", this.tableProps)
            }
            else if(this.type == "Facturas de SAT sin registro en SAP"){
                this.tableData = this.data.compare_transactions_sap.invoices.value.filter((item)=> moment(item.date_transaction).format('x') >= moment(this.start_date).format('x') && moment(item.date_transaction).format('x') <= moment(this.end_date).format('x'))
                this.tableData.sort((a,b) => moment(b.date_transaction).format('x') - moment(a.date_transaction).format('x'))
                
                this.tableData.forEach((element, index) => {
                    this.tableData[index].rfc = element.extra.tax_id
                });

                this.tableProps =  {
                    data: this.tableData,
                    columns: [
                        { title:"RFC", key: "rfc"},
                        { title:"Cliente", key: "description" },
                        { title:"Total", key: "amount", type: "number" },
                        { title:"Moneda", key: "currency" },
                        { title:"Fecha", key: "date_transaction" },
                        { title:"UUID", key: "reference" },
                    ],
                    //allowedExports: ['csv', 'json'], 
showDownloadButton:false,
                    lang: 'es',
                    text: {
                        perPageText: "Número de facturas por página :entries",
                        infoText: "Mostrando :first hasta :last de :total facturas",
                        emptyTableText: "No se encontraron facturas :(",
                        searchText: "Buscar",
                        paginationSearchButtonText :"Ir",
                        paginationSearchText: "Ir a la página",
                        downloadButtonText: "Descargar",
                        downloadText:"Exportar como:",
                        previousButtonText:"<",
                        nextButtonText:">"
                    },
                    sortingMode: "single",
                    //loadingComponent: Spinner,
                    isLoading: true,
                }
            }
            else if(this.type == "Pagos de SAT sin registro en SAP"){
                this.tableData = this.data.compare_transactions_sap.payments.value.filter((item)=> moment(item.date_transaction).format('x') >= moment(this.start_date).format('x') && moment(item.date_transaction).format('x') <= moment(this.end_date).format('x'))
                this.tableData.sort((a,b) => moment(b.date_transaction).format('x') - moment(a.date_transaction).format('x'))
                
                this.tableData.forEach((element, index) => {
                    this.tableData[index].rfc = element.extra.tax_id
                });

                this.tableProps =  {
                    data: this.tableData,
                    columns: [
                        { title:"RFC", key: "rfc"},
                        { title:"Cliente", key: "description" },
                        { title:"Total", key: "amount", type: "number" },
                        { title:"Moneda", key: "currency" },
                        { title:"Fecha", key: "date_transaction" },
                        { title:"UUID", key: "reference" },
                    ],
                    //allowedExports: ['csv', 'json'], 
showDownloadButton:false,
                    lang: 'es',
                    text: {
                        perPageText: "Número de facturas por página :entries",
                        infoText: "Mostrando :first hasta :last de :total facturas",
                        emptyTableText: "No se encontraron facturas :(",
                        searchText: "Buscar",
                        paginationSearchButtonText :"Ir",
                        paginationSearchText: "Ir a la página",
                        downloadButtonText: "Descargar",
                        downloadText:"Exportar como:",
                        previousButtonText:"<",
                        nextButtonText:">"
                    },
                    sortingMode: "single",
                    //loadingComponent: Spinner,
                    isLoading: true,
                }
            }
            else if(this.type == "Facturas conciliadas"){
                this.tableData = this.data.with_reference_on_sap.value.filter((item)=> moment(item.DocDate).format('x') >= moment(this.start_date).format('x') && moment(item.DocDate).format('x') <= moment(this.end_date).format('x'))
                this.tableData.sort((a,b) => moment(b.DocDate).format('x') - moment(a.DocDate).format('x'))
                this.tableProps =  {
                    data: this.tableData,
                    columns: [
                        { title:"Código", key: "CardCode"},
                        { title:"Cliente", key: "CardName" },
                        { title:"DocNum", key: "DocNum", type: "number" },
                        { title:"DocDate", key: "DocDate", type: "date" },
                        { title:"DocTotal", key: "DocTotal", type: "number" },
                        { title:"EDocNum", key: "EDocNum" },
                    ],
                    //allowedExports: ['csv', 'json'], 
showDownloadButton:false,
                    lang: 'es',
                    text: {
                        perPageText: "Número de facturas por página :entries",
                        infoText: "Mostrando :first hasta :last de :total facturas",
                        emptyTableText: "No se encontraron facturas :(",
                        searchText: "Buscar",
                        paginationSearchButtonText :"Ir",
                        paginationSearchText: "Ir a la página",
                        downloadButtonText: "Descargar",
                        downloadText:"Exportar como:",
                        previousButtonText:"<",
                        nextButtonText:">"
                    },
                    sortingMode: "single",
                    //loadingComponent: Spinner,
                    isLoading: true,
                }
            }
            this.tableProps.isLoading = false;
            this.isLoading = false;
        }
    }
};
</script>
<style>
</style>
